import React from "react";
export const AppContext = React.createContext({
	showReCaptchaBadge: false,
	toggleReCaptchaBadge: () => {},
	online: true,
});
